import React from "react";
import {
	Switch,
	Route,
	withRouter
} from "react-router-dom";
import RichMenuEditor from "./RichMenuEditor";

import './App.scss';
import MemberRoutes from "./MemberRoutes";

function App() {

	return (
		<>
			{/* {window.location.href} */}
			<Switch>
				<Route path="/backend/richmenus">
					<RichMenuEditor />
				</Route>
				<Route path="*">
					<MemberRoutes />
				</Route>
			</Switch>
		</>
	);
}

export default withRouter(App)